import React from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import UIInput from "../../../components/input/input";
import Button from "../../../components/buttons";
import UITextArea from "../../../components/atoms/textarea/UITextArea";
import UI from "../../../components/UI";
import UIUtils from "../../../utils/UIUtils";
import CommonUtil from "../../../utils/CommonUtil";
import ValidationUtil from "../../../common/validation/util/ValidationUtil";
import StringUtil from "../../../utils/StringUtil";

export default ContentsContainer;

function ContentsContainer(props: any) {
    const [sheet, setSheet] = React.useState<any>();
    const [state, setState] = React.useState<{
        subject: string;
        callback: string;
        reserved1Nm: string;
        smsMsg: string;
        totalRowCnt: number;
        destInfoList: any[]

    }>({
        subject: "SMS 발송 테스트",
        callback: "02-368-8700",
        reserved1Nm: "대·중소기업상생협력기금관리시스템",
        smsMsg: "",
        totalRowCnt: 0,
        destInfoList: []
    });

    const ibsheetCfg = {
        Cfg: {
            SearchMode: 1,
            AutoRowHeight: 1,
            InfoRowConfig: "0",
            Alternate:"0"
        },
        //틀고정 좌측 컬럼 설정
        LeftCols: [
            {Header: "No", Name: "SEQ", Width: "90"}
        ],
        Cols: [
            {Header: "No", Type: "Int", Name: "", Align: "Center", RelWidth: 1},
            {Header: "수신유형", Type: "Text", Name: "CALLBACK_TYPE", MinWidth: 50, Align: "Center", CanEdit: 0, RelWidth: 1},
            {Header: "수신자 SMS번호(*)", Type: "Text", Name: "PHONE_NUMBER", MinWidth: 60, Align: "Center", CanEdit: 1, RelWidth: 3},
            {Header: "수신자 이름(*)", Type: "Text", Name: "DEST_NAME", MinWidth: 40, Align: "Center", CanEdit: 1, RelWidth: 1}
        ]
    }

    //행 추가
    const rowAdd = () => {
        sheet.addRow({ visible: 1 });
        sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
        sheet.setValue({row:sheet.getLastVisibleRow(), col:"CALLBACK_TYPE", val:"TO", render:1});
        setState({...state, totalRowCnt:sheet.getDataRows().length});
    }

    // 행 삭제
    const rowDel = () => {
        sheet.removeRow( sheet.getFocusedRow(), null, 1);
        sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
        setState({...state, totalRowCnt:sheet.getDataRows().length});
    }

    //SMS직접발송
    async function smsDirect(){
        if(ValidationUtil.checkAll()) return;

        if(StringUtil.isEmpty(state.subject)){
            await UIUtils.alert("필수항목을 입력해 주세요.");
            return;
        }

        if(StringUtil.isEmpty(state.callback)){
            await UIUtils.alert("필수항목을 입력해 주세요.");
            return;
        }


        //@ts-ignore
        var saveJson = sheet.getSaveJson({saveMode:0});

        console.log("getSaveJson "+ JSON.stringify(saveJson.data));

        state.destInfoList = [];

        //파일등록 정보
        saveJson.data?.forEach((item, index) => {
            state.destInfoList.push({
                SMS_CALLBACK_TYPE:item.CALLBACK_TYPE,
                SMS_DEST_NUM:item.PHONE_NUMBER,
                SMS_DEST_NAME:item.DEST_NAME,
            });

        })

        if(state.destInfoList.length <= 0  ){
            await UIUtils.alert("필수항목을 입력해 주세요.");
            return;
        }


        //SMS내용 저장
        let param = {
            "MSG_ID":""
            ,"SMS_SEND_TYPE":"SEND"
            ,"SMS_SUBJECT": state.subject
            ,"SMS_CALLBACK":state.callback
            ,"SMS_MSG":state.smsMsg
            ,"SMS_DEST_INFO":state.destInfoList
        };
        setState({...state})


        console.log("smsDirect param "+ JSON.stringify(param));

        try {
            const response:any = await CommonUtil.execute({
                url:'adm_6220_smsSend',
                data: param,
                progressBar:true
            });
            if(response){
                UIUtils.alert("발송되었습니다.").then();
            }
        }
        catch (error) {
            CommonUtil.showAxiosError(error);
        }
    }

    function getByteLength(s:string){
        let b: number,i: number,c: number;
        for(b=i=0;c=s.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
        return b;
    }

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className="fww-con">
                <main className="fww-main">
                    <h1 className="tx tx-hd2">SMS 발송 테스트</h1>
                    <div className="fo fo-col2 mb30">
                        <div className="inner">
                            <div className="fo-item fo-m-1-3 req">
                                <p className="fo-key">SMS 제목</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={state.subject}
                                             valueChanged={(value) => setState({...state, subject: value})}
                                             placeholder="SMS 제목을 입력 하세요."
                                             rules={["required"]}
                                    />
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3">
                                <p className="fo-key">발송자 SMS 번호</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={state.callback}
                                             valueChanged={(value) => setState({...state, callback: value})}
                                             readOnly={true}
                                             placeholder=""
                                             rules={["required"]}
                                    />
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3">
                                <p className="fo-key">발송자 이름</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={state.reserved1Nm}
                                             valueChanged={(value) => setState({...state, reserved1Nm: value})}
                                             readOnly={true}
                                             placeholder=""
                                             rules={["required"]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tb-top">
                        <div>
                            <p className="tx fc-black"></p>총 <em className="fw500">{state.totalRowCnt}</em>건
                        </div>
                        <div className="hz-root hz-gap5">
                            <Button color="gray-o" size="sm" onClick={rowDel}>- 삭제</Button>
                            <Button color="gray-o" size="sm" onClick={rowAdd}>+ 추가</Button>
                        </div>
                    </div>
                    <UI.IBSheet data={[]} options={ibsheetCfg} onBind={ibsheet => {
                        ibsheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
                        setSheet(ibsheet);
                    }}/>
                    <br/>
                    <div className="fo fo-col2 mb30">
                        <div className="fo-item fo-m-1-3 req">
                            <div className="fo-key">SMS 내용</div>
                            <div className="fo-value">
                                <div className="ta-group w100p">
                                    <UITextArea className={'ta-ip'} value={state.smsMsg} valueChanged={(value) => {
                                        setState({...state, smsMsg: value})
                                    }} attrs={{rows: 5}}/>
                                    <div className="ta-right">{getByteLength(state.smsMsg)} bytes</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hz-root hz-right hz-gap5 mt10">
                        <Button color="pri-o" size="sm" onClick={smsDirect}>직접발송</Button>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}